import { useQuery } from 'react-query';

import { CardFlags } from '../../types/card-flags.enum';
import { api } from '../api';
import { TipoProd } from '../../types/TipoProd';

export interface ITransactionResumeResult {
  tipoProd: TipoProd;
  bandeira: CardFlags;
  vlTransacao: number;
  qtdTransacao: number;
}

interface IParams {
  docto: string;
  dtInicial: string;
  dtFinal: string;
}

export async function getVendas(
  params: IParams
): Promise<ITransactionResumeResult[]> {
  const { data } = await api.get('transactions/resume', {
    params,
  });

  return data;
}

export function useVendasResumo(params: IParams, pageName: string) {
  return useQuery(
    ['vendas-resumo', params.docto, params.dtInicial, params.dtFinal, pageName],
    () => getVendas(params),
    {
      staleTime: Infinity,
      enabled: String(api.defaults.headers.common.authorization).length > 10 && !!params.docto && !!pageName,
      retry: 2
    }
  );
}
